import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TextToSpeechService {
  private apiUrl = `${environment.smartPortalApiUrl}speech/text-to-speech`;

  //private baseUrl = `${environment.smartPortalApiUrl}Organization`;

  constructor(private http: HttpClient) {}

  convertTextToSpeech(text: string) {
    return this.http.post(this.apiUrl, { text }, { responseType: 'blob' });
  }
}
